<!--
 * @Description: 
 * @Author: 景 彡
 * @Date: 2023-06-05 17:20:38
 * @LastEditors: luckymiaow
-->
<script setup lang="ts">
import { computed, nextTick, ref, watch, watchEffect } from 'vue';
import { Popover as APopover } from 'ant-design-vue';

const props = withDefaults(
  defineProps<{
    text: string;
    maxLines?: number;
    trigger?: string; // 触发行为
    placement?: string; // 气泡框位置
    type?: string;
    hiddenBtn?: boolean;
  }>(),
  {
    text: '',
    maxLines: 3,
    trigger: 'hover',
    placement: 'top',
    type: 'tooltip ',
    hiddenBtn: true,
  }
);

const container = ref<HTMLElement>();
const more = ref<HTMLElement>();
const showPopoverVisible = ref(false);
const isOverflow = ref(false);

// watch(
//   () => props.text,
//   () => {
//     showPopoverVisible.value = false;
//     nextTick(() => {
//       checkOverflow();
//     });
//   },
//   {
//     immediate: true,
//   }
// );

function checkOverflow() {
  const containerElement = container.value;
  const moreElement = more.value;
  if (!containerElement || !moreElement) return;

  const lineHeight = parseInt(window.getComputedStyle(containerElement).lineHeight, 10);
  const { maxLines } = props;

  const isOverflowValue = containerElement.scrollHeight > lineHeight * maxLines;
  if (isOverflowValue) {
    contentStyle.value = `overflow: hidden; -webkit-line-clamp: ${maxLines}; display: -webkit-box; -webkit-box-orient: vertical;`;
    moreElement.style.display = 'inline';
  } else {
    contentStyle.value = '';
    moreElement.style.display = 'none';
  }

  isOverflow.value = isOverflowValue;
}

const contentStyle = ref('');

const displayContent = ref('');
const fullContent = ref('');

watch(
  () => props.text,
  () => {
    showPopoverVisible.value = false;
    nextTick(() => {
      checkOverflow();
    });
    const textLines = props.text.split('\n');
    const displayLines = isOverflow.value ? textLines.slice(0, props.maxLines) : textLines;
    displayContent.value = displayLines.join('\n');
    fullContent.value = props.text;
  },
  { immediate: true }
);

/** 方案2 */
const showall = ref(true);
const textStyleObject = computed(() => {
  return {
    'max-height': showall.value ? 'none' : `${1.5 * props.maxLines}em`,
  };
});

const showLabel = ref(false);

const domBoxRef = ref<HTMLDivElement>();

const textClass = computed(() => {
  let cls = showall.value ? 'showall' : '';
  cls += props.hiddenBtn ? ' hidden-btn' : '';
  return cls;
});

async function isTextWrapped() {
  await nextTick();
  const element = domBoxRef.value;
  if (!element) return;
  const computedStyle = window.getComputedStyle(element);
  showLabel.value = element.offsetHeight > props.maxLines * parseFloat(computedStyle.lineHeight);
  if (showLabel.value) showall.value = false;
}

watch(
  () => props.text,
  () => {
    isTextWrapped();
  },
  {
    immediate: true,
  }
);
</script>

<script lang="ts">
export default {
  name: 'TruncatedText',
};
</script>

<template>
  <div v-if="type === 'tooltip '" class="more-content">
    <div ref="container" class="content" :style="contentStyle">
      {{ displayContent }}
    </div>
    <a-popover v-model:visible="showPopoverVisible" :trigger="trigger" :placement="placement">
      <template #content>
        <div style="max-width: 60vw">{{ fullContent }}</div>
      </template>
      <span v-show="isOverflow" ref="more" class="more">更多</span>
    </a-popover>
  </div>
  <div v-else class="dp-text-ellipsis-wrapper">
    <div ref="domBoxRef" class="text" :class="textClass" :style="textStyleObject">
      <label v-if="showLabel" class="btn" @click="showall = !showall"></label>
      {{ text }}
    </div>
  </div>
</template>

<style scoped lang="less">
.more-content {
  position: relative;
  display: flex;
  align-items: flex-end;
}

.content {
  white-space: pre-wrap;
}

.more {
  display: block;
  min-width: 50px;
  cursor: pointer;
  color: #1890ff;
}

.dp-text-ellipsis-wrapper {
  display: flex;
  margin: 6px 0 20px 0;
  overflow: hidden;
  font-size: 14px;
  line-height: 20px;

  .text {
    position: relative;
    overflow: hidden;
    line-height: 1.5;
    text-align: justify;
    text-overflow: ellipsis;
    word-break: break-all;
    transition: 0.3s max-height;
  }
  .text::before {
    float: right;
    height: calc(100% - 20px);
    content: '';
  }
  .text::after {
    position: absolute;
    width: 999vw;
    height: 999vw;
    margin-left: -100px;
    box-shadow: inset calc(100px - 999vw) calc(30px - 999vw) 0 0 #fff;
    content: '';
  }
  .btn {
    position: relative;
    float: right;
    clear: both;
    margin-left: 10px;
    font-size: 14px;
    padding: 0 8px;
    color: #206ef7;
    line-height: 20px;
    border-radius: 4px;
    cursor: pointer;
    z-index: 10;
  }
  .btn::after {
    /* stylelint-disable-next-line */
    font-family: element-icons !important;
    content: '全部';
  }

  .text.showall {
    max-height: none;
  }
  .text.showall .btn::before {
    visibility: hidden;
  }
  .text.showall .btn::after {
    visibility: hidden;
  }
  .text.showall.hidden-btn .btn::after {
    content: '收起';
    visibility: visible;
  }
  .btn::before {
    position: absolute;
    left: 1px;
    color: #333;
    transform: translateX(-100%);
    content: '...';
  }
}
</style>
